import BaseService from '_services/rest/base';

class AccessControlService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}/api/access-control`;
  }

  getUrlSave(id, url = '') {
    const resource = url ? `/${url.replace(/^\/+|\/+$/g, '')}` : '';

    if (id) {
      return {
        url: `${this.getUrl()}${resource}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${resource}`,
      method: 'POST',
    };
  }

  getRoles() {
    return this.request(`${super.getUrl()}/api/user/role/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTypes() {
    return this.request(`${super.getUrl()}/api/user/type/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getPermissions(id) {
    return this.request(`${this.getUrl()}/role/${id}/permissions`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUsers() {
    return this.request(`${this.getUrl()}/user`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  setRole(param) {
    return this.request(`${this.getUrl()}/user/${param.id}`, { role_id: param.settings.role_id }, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  removeRoles(id) {
    return this.request(`${this.getUrl()}/role/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveRoles(role) {
    const meta = this.getUrlSave(role.id, 'role');
    return this.request(meta.url, role, meta.method)
      .catch(err => {
        throw err;
      });
  }

  savePermissions(permission, roleId) {
    return this.request(`${this.getUrl()}/role/${roleId}/permissions`, permission, 'POST')
      .catch(err => {
        throw err;
      });
  }
}

export default new AccessControlService();
